export default __webpack_public_path__ + "static/media/shopping.085e8231.svg";